<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-password
    type="text"
    [id]="field.id"
    [placeholder]="props.placeholder"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [promptLabel]="props.promptLabel ? props.promptLabel : null"
    [mediumRegex]="
      props.mediumRegex ? props.mediumRegex : mediumRegexPrimeDefault
    "
    [strongRegex]="
      props.strongRegex ? props.strongRegex : strongRegexPrimeDefault
    "
    [weakLabel]="props.weakLabel"
    [mediumLabel]="props.mediumLabel"
    [strongLabel]="props.strongLabel"
    [feedback]="props.feedback"
    [toggleMask]="props.toggleMask"
    [appendTo]="props.appendTo ? props.appendTo : 'body'"
    [inputStyle]="props.inputStyle"
    [inputStyleClass]="props.inputStyleClass"
    [inputId]="field.id"
    [style]="props.style"
    [styleClass]="styleClass"
    [ariaLabel]="props.ariaLabel"
    [ariaLabelledBy]="props.ariaLabelledBy"
    [showClear]="props.showClear ? props.showClear : false"
    (keydown)="props.keydown ?? onKeyDown($event)"
  >
  </p-password>
</span>
